import request from '@/utils/request'

// 전역적으로 사용되는 form이나 요소 파라미터를 생성한다.
export function makeGlobalReqParam(frmObj) {
    var retObj = {}
    retObj = frmObj
    return retObj
}

// 새 계약작성 단계별 파라미터를 생성한다
export function makeNewCtrParamsByStep(frmObj, stepNo) {
    var retObj = {}
    if (stepNo === 1 || stepNo === 2 || stepNo === 3) {
        retObj = frmObj
    }
    return retObj
}

// 사업자 등록번호 형식을 만들어준다
export function regNumTxt(value) {
    var regNumPattern = /(\d{3})(\d{2})(\d{5})/
    var retTxt = ''

    if (value !== undefined && value != null && value !== '') {
        if (regNumPattern.test(value)) {
            retTxt = String(value).replace(regNumPattern, '$1-$2-$3')
        } else {
            retTxt = value
        }
    }

    return retTxt
}

// 계약서를 업로드 한다
export function ctrPaperFileUpload(data) {
    return request({
        url: '/v2/sec/contract/uploadCtrFile',
        method: 'post',
        data
    })
}

// 계약정보설정된 메타 데이터를 가져온다
export function getSettingContract(params) {
    return request({
        url: '/v2/sec/contract/getSettingContract',
        method: 'post',
        data: params
    })
}

// 저장이나 계약요청전 PDF 파일의 상태를 체크한다
export function validateConvPDFPath(data) {
    return request({
        url: '/v2/sec/contract/chkValidConvPDFPath',
        method: 'post',
        data
    })
}

// PDF 파일 썸네일을 생성한다
export function reqMakeConvPDFThumb(data) {
    return request({
        url: '/v2/sec/contract/reqMakeConvPDFThumb',
        method: 'post',
        data
    })
}

// 저장이나 계약요청전 PDF 파일(워터마크)의 상태를 체크한다
export function validateConvWmPDFPath(data) {
    return request({
        url: '/v2/sec/contract/chkValidConvWmPDFPath',
        method: 'post',
        data
    })
}

// 최종 데이터를 DB에 인서트 한다(계약요청) : csy > 한번 호출하도록 통합
export function writeContractData(data) {
    var json = JSON.stringify(data)
    return request({
        url: '/v2/sec/contract/writeContractData',
        method: 'post',
        data: json
    })
}

// 각 단계에서 저장된 form field 데이터를 가진 object를
// 파라미터 전송용으로 변환한다
export function convFrmDataToReqJsonParam(jsonObj) {
    var retObj = {}
    if (jsonObj != null) {
        for (var frmKey in jsonObj) {
            var frmData = jsonObj[frmKey]
            for (var key in frmData) {
                // Array데이터는 보통 뒷단에서 추출,사용하므로 원형대로 뽑는다
                if (frmData instanceof Array) {
                    retObj[frmKey] = frmData
                } else {
                    retObj[key] = frmData[key]
                }
            }
        }
    }
    return retObj
}

// 일반 문자 시작 문자 숫자 검사
// @return boolean
export function chkInclFirstLetterNumTxt(txtStr) {
    var charPattern = /^[0-9]/
    var chkPattern = new RegExp(charPattern)
    var hasValueFirstNumLetter = false

    if (chkPattern.exec(txtStr) != null) {
        hasValueFirstNumLetter = true
    } else {
        hasValueFirstNumLetter = false
    }
    return hasValueFirstNumLetter
}

// 일반 문자 시작 문자 공백 검사
export function chkInclFirstLetterWhiteSpaceTxt(txtStr) {
    var charPattern = /^\s+$/
    var chkPattern = new RegExp(charPattern)
    var hasValueFirsLetterWhiteSpace = false

    if (chkPattern.exec(txtStr) != null) {
        hasValueFirsLetterWhiteSpace = true
    } else {
        hasValueFirsLetterWhiteSpace = false
    }
    return hasValueFirsLetterWhiteSpace
}

// 일반 문자 특수문자 검사
// @return boolean
export function chkInclSpecialCharTxt(txtStr) {
    var specialCharPattern = /[{}[\]/?.,;:|)*~`!^\-_+<>#$%&\\=('"]/gi
    var chkPattern = new RegExp(specialCharPattern)
    var hasValueSpecialChar = false

    if (chkPattern.exec(txtStr) != null) {
        hasValueSpecialChar = true
    } else {
        hasValueSpecialChar = false
    }
    return hasValueSpecialChar
}

// 업로드 된 계약서를 PDF로 변환요청 한다
export function reqCtrPaperConvToPDF(data) {
    return request({
        url: '/v2/sec/contract/reqCtrPaperConvToPDF',
        method: 'post',
        data
    })
}

// 사용자 정보를 가져온다
export function getUserTokenData(data) {
    var json = JSON.stringify(data)
    return request({
        url: '/v2/sec/contract/getUserTokenData',
        method: 'post',
        data: json
    })
}

// PDF 변환요청 후 변환 상태를 체크한다
export function chkConvPdfStatus(data) {
    return request({
        url: '/v2/sec/contract/chkConvPdfStatus',
        method: 'post',
        data
    })
}

// 계약서의 첨부파일을 업로드 한다
export function ctrPaperAttachUpload(data) {
    return request({
        url: '/v2/sec/contract/uploadCtrAttachFile',
        method: 'post',
        data
    })
}

// 서명을 위해 계약의 파일을 Hash로 변환한다.
export function getCtrFileHash(data) {
    var json = JSON.stringify(data)
    return request({
        url: '/v2/sec/contract/getCtrFileHash',
        method: 'post',
        data: json
    })
}

export function validateBkPass(data) {
    var json = JSON.stringify(data)
    return request({
        url: '/v2/sec/contract/validateBkPass',
        method: 'post',
        data: json
    })
}

export function defaultConstValue() {
    return Object.freeze({
        receiverInfoBtnMode: {
            auto: 'A',
            manual: 'M'
        },
        receiverInfoCat: {
            org: 'org',
            usr: 'usr'
        },
        receiverBrokerInfoCat: {
            org: 'org',
            usr: 'usr'
        },
        frmName: {
            ctrGlobalFrm: 'ctrGlobalFrm',
            ctrFrmStep1: 'ctrFrmStep1',
            ctrFrmStep2: 'ctrFrmStep2',
            ctrFrmStep3: 'ctrFrmStep3',
            ctrFrmStep3A: 'ctrFrmStep3A',
            ctrFrmBaseData: 'ctrFrmBaseData'
        },
        ctrTblListName: 'ctrTblList',
        ctrTblKeys: {
            ctrOrder: 'ctrOrder',
            ownerAddress: 'ownerAddress',
            ownerName: 'ownerName',
            senderAddress: 'senderAddress',
            senderName: 'senderName',
            senderBrokerAddress: 'senderBrokerAddress',
            senderBrokerName: 'senderBrokerName',
            receiverAddress: 'receiverAddress',
            receiverName: 'receiverName',
            receiverBrokerAddress: 'receiverBrokerAddress',
            receiverBrokerName: 'receiverBrokerName',
            receiverOrgNum: 'receiverOrgNum',
            receiverEmail: 'receiverEmail',
            receiverPhone: 'receiverPhone',
            receiverKey: 'receiverKey'
        },
        ctrKind: {
            personal: 'PERSONAL',
            broker: 'BROKER'
        },
        ctrLockType: {
            Office: 'OFFICE',
            Email: 'EMAIL',
            Phone: 'PHONE',
            Key: 'KEY'
        },
        ctrSignType: {
            simpleSign: 'SIMPLE',
            authSign: 'AUTH'
        },
        ctrSignData: {

        },
        rcvSrchKind: {
            personal: 'PSNL_RECEIVER',
            broker: 'ORG_RECEIVER'
        },
        ctrComposeMode: {
            upload: 'UPLOAD',
            write: 'WRITE'
        },
        ctrComposeFrmGbn: {
            personal: 'PSNL',
            company: 'ORGN'
        },
        tabName: {
            companyFrmTab: 'companyFrmTab',
            personalFrmTab: 'personalFrmTab'
        },
        webEditContentName: 'ctrWebEditContent',
        ctrReqMode: {
            ctrReq: 'CTR_REQ',
            ctrSave: 'CTR_SAVE'
        },
        reqParamKeys: {
            tmpUploadData: 'tmpUploadData',
            metaData: 'metaData',
            pdfConvReqPrcInfo: 'pdfConvReqPrcInfo',
            userToken: 'userToken'
        },
        ctrPaperUpInfoKeys: {
            oriFileName: 'oriFileName',
            uploadFileName: 'uploadFileName',
            uploadPDFFileName: 'uploadPDFFileName',
            uploadWmPDFFileName: 'uploadWmPDFFileName',
            convPDFFileLoc: 'convPDFFileLoc',
            file: 'file',
            ctrPaperData: 'ctrPaperData'
        },
        ctrPaperReUpInfoKeys: {
            file: 'file',
            ctrPaperReUpData: 'ctrPaperReUpData'
        },
        ctrPaperAttachInfoKeys: {
            uid: 'uid',
            file: 'file',
            ctrPaperAttachData: 'ctrPaperAttachData',
            ctrPaperAttachInfo: 'ctrPaperAttachInfo',
            upload: 'upload',
            ctrTmpAttachList: 'ctrTmpAttachList'
        }
    })
}